import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyT = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.86515 16C1.03658 16 0.104004 15.0852 0.104004 13.2739V2.71698C0.104004 0.914808 1.03658 0 2.86515 0H13.352C15.1806 0 16.104 0.914808 16.104 2.71698V13.2739C16.104 15.0852 15.1806 16 13.352 16H2.86515ZM2.91086 14.5089H13.2971C14.1383 14.5089 14.6137 14.0606 14.6137 13.1824V2.81761C14.6137 1.93939 14.1383 1.49114 13.2971 1.49114H2.91086C2.06972 1.49114 1.60343 1.93939 1.60343 2.81761V13.1824C1.60343 14.0606 2.06972 14.5089 2.91086 14.5089ZM8.08572 11.984C7.61029 11.984 7.35429 11.6455 7.35429 11.1515V5.20526H5.29715C4.94058 5.20526 4.68458 4.96741 4.68458 4.60149C4.68458 4.22642 4.94058 3.99771 5.29715 3.99771H10.9109C11.2766 3.99771 11.5326 4.22642 11.5326 4.60149C11.5326 4.96741 11.2766 5.20526 10.9109 5.20526H8.83543V11.1515C8.83543 11.6638 8.57943 11.984 8.08572 11.984Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
